module.exports = __webpack_public_path__ + "img/9791195567836.e28b6b7d.jpg";